module.exports = __webpack_public_path__ + "static/media/proj20_img5.6dbfc4fe.jpg";